import { message, Upload } from 'antd';
import Uploader, { UploaderProps } from './Uploader';
import { useTranslate } from '@tolgee/react';

export interface PdfUploaderProps extends UploaderProps {}

function PdfUploader(props: PdfUploaderProps) {
  const { children, ...otherProps } = props;

  const { t } = useTranslate();

  return (
    <Uploader
      accept=".pdf"
      beforeUpload={(file) => {
        const uploadSizeLimit = 20 * 1024 * 1024;

        if (file.size > uploadSizeLimit) {
          message.warn(t('超出限制xM大小', { x: (uploadSizeLimit / 1024 / 1024).toFixed(2) }));

          return Upload.LIST_IGNORE;
        }

        return Promise.resolve();
      }}
      {...otherProps}
    >
      {children}
    </Uploader>
  );
}

export default PdfUploader;
